import React from 'react';

export const SpaceBackground: React.FC = () => <div className="hero__space-bg" aria-hidden />;
